import { render, staticRenderFns } from "./PrizeItem.vue?vue&type=template&id=598af9cc&scoped=true&"
import script from "./PrizeItem.vue?vue&type=script&lang=js&"
export * from "./PrizeItem.vue?vue&type=script&lang=js&"
import style0 from "./PrizeItem.vue?vue&type=style&index=0&id=598af9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598af9cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('598af9cc')) {
      api.createRecord('598af9cc', component.options)
    } else {
      api.reload('598af9cc', component.options)
    }
    module.hot.accept("./PrizeItem.vue?vue&type=template&id=598af9cc&scoped=true&", function () {
      api.rerender('598af9cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/weeklylogin/campaign/components/PrizeItem.vue"
export default component.exports